import React, { useEffect, useState } from "react";
import AHeader from "../component/AHeader";
import AFooter from "../component/AFooter";
import axios from "axios";
import { toast } from "react-toastify";
import { redirect } from "react-router-dom";

function Manage_services() {
  useEffect(() => {
    fetch();
    fetch1();
    document.getElementById('spinner').style.display = "none";
  }, []);

  const [data, setData] = useState([]);
  const fetch = async () => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/services_get`);
    console.log(res.data);
    setData(res.data);
  };

  //get cate for edit services
  const [data1, setData1] = useState([]);
  const fetch1 = async () => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/categories_get`);
    console.log(res.data);
    setData1(res.data);
  }

  const deletehand = async (id) => {
    const res = await axios.delete(`https://www.rajvicosmeticclinic.com/RajviApi/services_delete?id=${id}`);
    toast.success(res.data.message);
    fetch();
  };

  const [id, setid] = useState('');
  const [cate_id, setcate_id] = useState('');
  const [service_name, setservice_name] = useState('');
  const [description, setdescription] = useState('');
  const [price, setprice] = useState('');
  const [ser_img, setser_img] = useState('');



  const edithandle = async (id) => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/services_single?id=${id}`);

    setid(res.data[0].id);
    setcate_id(res.data[0].cate_id);
    setservice_name(res.data[0].service_name);
    setdescription(res.data[0].description);
    setprice(res.data[0].price);
    setser_img(res.data[0].ser_img);
  };

  function validation() {
    var ans = true;
    if (cate_id == "") {
      toast.error("Category Field is required");
      ans = false;
      return false;
    }

    if (service_name == "") {
      toast.error("Service Name Field is required");
      ans = false;
      return false;
    }

    if (description == "") {
      toast.error(" Description Field is required");
      ans = false;
      return false;
    }
    if (price == "") {
      toast.error("Services Price is required");
      ans = false;
      return false;
    }
    if (ser_img == "") {
      toast.error("Services Image is required");
      ans = false;
      return false;
    }
    return ans;
  }


  const onSubmit = async (event) => {
    event.preventDefault();
    if (validation()) {
      const formData = new FormData();
      formData.append('cate_id', cate_id);
      formData.append('service_name', service_name);
      formData.append('description', description);
      formData.append('price', price);
      formData.append('ser_img', ser_img);

      const res = await axios.post(
        `https://www.rajvicosmeticclinic.com/RajviApi/services_put?id=${id}`,
        formData, {
        headers: { 'Content-Type': "multipart/form-data" }
      }
      )
      console.log(res);
      toast.success("Service Update Success");
      fetch();
    }
  };
  return (
    <div>
      <AHeader title="Manage Services" />
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className=" col-lg-12 ">
              <div className="bg-light  p-lg-5">
                <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                  Services
                </h6>
                <h1 className="mb-4">Manage Services</h1>
                <div className='justify-content-center text-center mb-5' id='spinner'>
                  <div class="spinner-border text-danger mt-5"></div>
                </div>

                <table className="table">
                  <thead className="table-dark">
                    <tr>
                      <th>ID</th>
                      <th>Categories ID</th>
                      <th>Service Image</th>
                      <th>Service Name</th>
                      <th>Main Price</th>
                      <th>service description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      (data.length > 0) ? data.map((value) => {
                        return (
                          <tr>
                            <td>{value.id}</td>
                            <td>{value.cate_id}</td>
                            <td>
                              <img src={`https://www.rajvicosmeticclinic.com/RajviApi/upload/services/${value.ser_img}`} height={100} alt="" />
                            </td>
                            <td>{value.service_name}</td>
                            <td>{value.price}</td>
                            <td>{value.description}</td>
                            <td>
                              <button
                                className="btn btn-info mr-2"
                                data-toggle="modal"
                                data-target="#exampleModal"
                                onClick={() => edithandle(value.id)}
                              >
                                <i
                                  className="fas fa-pen-fancy"
                                  style={{ fontSize: 20 }}
                                />
                              </button>
                              <button
                                className="btn btn-danger"
                                onClick={() => deletehand(value.id)}
                              >
                                <i className="fa fa-trash" />
                              </button>
                            </td>
                          </tr>
                        );
                      }) : null}
                  </tbody>
                </table>
                <div
                  class="modal fade"
                  id="exampleModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                          Edit Services
                        </h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <form role="form" method="post" enctype="multipart/form-data">
                          <div className="form-group">
                            <label> Edit Service Name </label>
                            <select
                              onChange={(e) => setcate_id(e.target.value)}
                              name="cate_id"
                              className="form-control"
                            >

                              <option value="">Select Categories</option>
                              {data1 &&
                                data1.map((value) => {
                                  if (value.id == cate_id) {
                                    return (
                                      <option value={value.id} selected>{value.cate_name}</option>
                                    );
                                  }
                                  else {
                                    return (
                                      <option value={value.id}>{value.cate_name}</option>
                                    );
                                  }
                                })}
                            </select>
                          </div>
                          <div className="form-group">
                            <label> Edit Service Name </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter the Service Name here..."
                              name="service_name"
                              value={service_name}
                              onChange={(e) => setservice_name(e.target.value)}
                            />
                          </div>
                          <div className="form-group">
                            <label> Edit Service Description </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter the Service Description"
                              name="description"
                              value={description}
                              onChange={(e) => setdescription(e.target.value)}
                            />
                          </div>

                          <div className="form-group">
                            <label> Edit Service Price</label>
                            <input
                              className="form-control"
                              type="number"
                              placeholder="Enter Service Price"
                              name="price"
                              value={price}
                              onChange={(e) => setprice(e.target.value)}
                            />
                          </div>

                          <div className="form-group">
                            <label> Edit Service Image </label>
                            <input
                              className="form-control"
                              type="file"
                              placeholder="Upload Service Image"
                              name="ser_img"
                              onChange={(e) => setser_img(e.target.files[0])}
                            />
                            <img src={`https://www.rajvicosmeticclinic.com/RajviApi/upload/services/${ser_img}`} height={50} alt="" />
                          </div>

                          <hr />
                          <div className="text-center"></div>
                        </form>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary  "
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={onSubmit}
                        >
                          Save changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AFooter />
    </div>
  );
}

export default Manage_services;
